import { actions as simpleActions } from '../slice';

import * as privacyPolicyActions from './privacyPolicy';

export const actions = { ...privacyPolicyActions, ...simpleActions };
